module.exports = __webpack_public_path__ + "static/media/scooter.53f9d99b.svg";